import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { BUSINESS_NAME, CALL_URL, CONTACT_ADDRESS, CONTACT_PHONE_DISPLAY } from "../config";
import "../styles/Legal.css";

// How to reach the business, the same on both pages.
export function LegalContact() {
    return (
        <ul>
            <li><strong>{BUSINESS_NAME}</strong></li>
            <li>{CONTACT_ADDRESS}</li>
            <li>Call <a href={CALL_URL}>{CONTACT_PHONE_DISPLAY}</a></li>
        </ul>
    );
}

// The layout shared by the Privacy Policy and the Terms and Conditions: the
// title, the date, a short summary, a list of the sections, then the
// sections, numbered in the order they are given.
//   sections: [{ id, title, body }]
function LegalPage({ title, intro, updated, summary, sections, other }) {
    // The footer opens these pages from the bottom of another page: start at the top.
    useEffect(() => {
        if (!window.location.hash) window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <Header />
            <main>
                <div className="legal-banner">
                    <div>
                        <h1>{title}</h1>
                        <p>{intro}</p>
                    </div>
                </div>

                <div className="legal">
                    <p className="legal-updated">Last updated: {updated}</p>

                    <div className="legal-short">
                        <h2>In short</h2>
                        <ul>
                            {summary.map((point, index) => <li key={index}>{point}</li>)}
                        </ul>
                    </div>

                    <nav className="legal-toc" aria-label="Sections on this page">
                        <h2>On this page</h2>
                        <ol>
                            {sections.map((section) => (
                                <li key={section.id}><a href={`#${section.id}`}>{section.title}</a></li>
                            ))}
                        </ol>
                    </nav>

                    {sections.map((section, index) => (
                        <section id={section.id} key={section.id}>
                            <h2><span className="legal-num">{index + 1}.</span> {section.title}</h2>
                            {section.body}
                        </section>
                    ))}

                    <p className="legal-other">
                        See also the <Link to={other.to}>{other.label}</Link>.
                    </p>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default LegalPage;
